import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import StatusChip from "@/components/StatusChip";
import { inr, fmtDate, LIFECYCLE } from "@/lib/constants";
import { Input } from "@/components/ui/input";

export default function CasesList() {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("All");

  useEffect(() => {
    api.get("/cases").then(r => setCases(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = cases.filter(c => {
    const matchesQ = !q || c.title.toLowerCase().includes(q.toLowerCase()) || c.case_number.toLowerCase().includes(q.toLowerCase());
    const matchesS = status === "All" || c.status === status;
    return matchesQ && matchesS;
  });

  return (
    <div className="space-y-6" data-testid="cases-list">
      <div>
        <h1 className="font-display text-3xl font-bold text-court">Cases</h1>
        <p className="text-muted-foreground">All cases visible to you, ordered by latest.</p>
      </div>
      <div className="flex flex-wrap gap-3">
        <Input data-testid="cases-search" placeholder="Search title or case #" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-sm h-10 rounded-sm" />
        <select value={status} onChange={(e) => setStatus(e.target.value)} className="h-10 rounded-sm border border-stone/60 bg-card px-3 text-sm" data-testid="cases-status-filter">
          <option>All</option>
          {LIFECYCLE.map(s => <option key={s}>{s}</option>)}
        </select>
      </div>
      <div className="bg-card rounded-sm border border-stone/60  overflow-x-auto">
        {loading ? <div className="p-6 text-muted-foreground">Loading…</div> : filtered.length === 0 ? <div className="p-6 text-muted-foreground">No cases found.</div> : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs uppercase tracking-[0.16em] text-muted-foreground">
              <th className="p-3">Case #</th><th className="p-3">Title</th><th className="p-3">Type</th><th className="p-3">Claimant</th><th className="p-3">Mediator/Arbitrator</th><th className="p-3">Claim</th><th className="p-3">Status</th><th className="p-3">Filed</th>
            </tr></thead>
            <tbody className="divide-y divide-border">
              {filtered.map(c => (
                <tr key={c.id} className="hover:bg-slate-50" data-testid={`case-row-${c.case_number}`}>
                  <td className="p-3 font-mono text-xs">{c.case_number}</td>
                  <td className="p-3"><Link to={`/app/cases/${c.id}`} className="text-court font-medium hover:underline">{c.title}</Link></td>
                  <td className="p-3 capitalize">{c.type}</td>
                  <td className="p-3">{c.claimant?.name || "—"}</td>
                  <td className="p-3">{c.assigned_neutral?.name || <span className="text-muted-foreground italic">Unassigned</span>}</td>
                  <td className="p-3 font-semibold">{inr(c.claim_amount)}</td>
                  <td className="p-3"><StatusChip status={c.status} /></td>
                  <td className="p-3 text-muted-foreground">{fmtDate(c.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
